module.exports = __webpack_public_path__ + "img/unifesp.d04c161d.svg";